import { Phone, MessageSquare, Check, Clock, Shield } from "lucide-react";

export default function CTASection() {
  return (
    <section className="max-w-[90%] xl:max-w-6xl mx-auto mb-24">
      <div className="relative bg-gray-950 rounded-[28px] px-8 md:px-16 py-18 overflow-hidden">

        {/* Grid texture */}
        <div
          className="absolute inset-0 pointer-events-none opacity-100"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
                              linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)`,
            backgroundSize: "40px 40px",
          }}
        />

        {/* Blue glow blobs */}
        <div className="absolute -top-32 -right-20 w-[420px] h-[420px] rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(37,99,235,0.35) 0%, transparent 70%)", filter: "blur(80px)" }} />
        <div className="absolute -bottom-16 left-20 w-[260px] h-[260px] rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(59,130,246,0.18) 0%, transparent 70%)", filter: "blur(80px)" }} />

        {/* Decorative pipe SVG */}
        <svg className="absolute top-0 right-0 w-80 h-full opacity-[0.07] pointer-events-none"
          viewBox="0 0 320 500" preserveAspectRatio="xMaxYMid slice">
          <rect x="180" y="0" width="8" height="180" rx="4" fill="white"/>
          <rect x="180" y="180" width="120" height="8" rx="4" fill="white"/>
          <rect x="292" y="180" width="8" height="140" rx="4" fill="white"/>
          <rect x="220" y="312" width="80" height="8" rx="4" fill="white"/>
          <rect x="220" y="312" width="8" height="100" rx="4" fill="white"/>
          <rect x="80" y="80" width="8" height="220" rx="4" fill="white"/>
          <rect x="80" y="80" width="80" height="8" rx="4" fill="white"/>
          <circle cx="180" cy="180" r="8" fill="white"/>
          <circle cx="292" cy="320" r="6" fill="white"/>
          <circle cx="80" cy="300" r="6" fill="white"/>
        </svg>

        {/* Content */}
        <div className="relative z-10 flex flex-col lg:flex-row items-center gap-12">

          {/* Copy */}
          <div className="flex-1 max-w-xl">
            <div className="inline-flex items-center gap-2 bg-blue-600/20 border border-blue-400/30 text-blue-300
              text-[11px] font-bold tracking-[0.13em] uppercase px-4 py-1.5 rounded-full mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
              Ready to help right now
            </div>

            <h2 className="font-serif text-4xl lg:text-5xl text-slate-50 leading-[1.1] tracking-tight mb-5">
              Got a plumbing problem?{" "}
              <em className="text-blue-400 not-italic">Let's fix it today.</em>
            </h2>

            <p className="text-slate-400 text-base leading-relaxed mb-9 max-w-md">
              Whether it's a dripping faucet or a full-blown emergency, our Chicago
              team is standing by. Same-day service, upfront pricing — no surprises.
            </p>

            <div className="flex items-center flex-wrap gap-6">
              {[
                { icon: Check, label: "Licensed & Insured" },
                { icon: Clock, label: "Same-Day Service" },
                { icon: Shield, label: "Satisfaction Guaranteed" },
              ].map(({ icon: Icon, label }, i) => (
                <div key={i} className="flex items-center gap-2 text-slate-300 text-sm font-semibold">
                  <Icon className="w-4 h-4 text-blue-400" />
                  {label}
                </div>
              ))}
            </div>
          </div>

          {/* CTA Card */}
          <div className="bg-white/5 border border-white/10 rounded-[20px] p-8 min-w-[260px] flex flex-col gap-4 backdrop-blur-sm w-full lg:w-auto">
            <div>
              <p className="text-[11px] font-bold tracking-widest uppercase text-slate-500 mb-1">
                Call us directly
              </p>
              <p className="font-serif text-[28px] text-slate-100 leading-none tracking-tight">
                (312) 555-0147
              </p>
            </div>

<a            
              href="tel:(312) 555-0147"
              className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700
                text-white font-bold text-sm py-3.5 rounded-xl transition-all
                shadow-[0_4px_24px_rgba(37,99,235,0.4)] hover:-translate-y-px"
            >
              <Phone className="w-4 h-4" />
              Call Now — It's Free
            </a>

            <div className="h-px bg-white/[0.07]" />

            <a
              href="#footer"
              className="flex items-center justify-center gap-2 border border-white/10
                hover:border-white/20 hover:bg-white/[0.06] text-slate-300 font-semibold
                text-sm py-3 rounded-xl transition-all"
            >
              <MessageSquare className="w-4 h-4" />
              Send Us a Message
            </a>

            <div className="flex items-center gap-2 text-slate-500 text-xs font-medium">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse flex-shrink-0" />
              Available now · Typical response &lt; 5 min
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}